const messages = {
    title: 'Tournament of Towns',
    'UnderConstructionPage.note': 'Uploading papers to the marking system will be available later.',
    'ExternalPageTemplate.TofT': 'Tournament of Towns',

    'SignUpPage.You need to register': "You need to register in order to upload participants' papers.",
    'SignUpPage.town': 'Town',
    'SignUpPage.name': 'Name',
    'SignUpPage.email': 'Email',
    'SignUpPage.register': 'Register',
    'SignUpPage.Already registered?': 'Already registered?',
    'SignUpPage.Sign in': 'Sign in',
    'SignUpPage.Cannot register': 'Cannot register this user.',
    'SignUpPage.Fill in town name': 'Enter town name',
    'SignUpPage.Fill in name': 'Enter your name',
    'SignUpPage.Wrong email': 'Invalid email',
    'SignUpPage.Email sent':
        'You have been successfully registered. Please follow the link sent to {email} to confirm you email.',

    'SignInPage.Sign In to the system': 'Sign in to the marking system',
    'SignInPage.No account?': 'No account?',
    'SignUpPage.Sign up': 'Register',
    'SignInPage.email': 'Email',
    'SignInPage.password': 'Password',
    'SignInPage.sign in': 'Sign in',
    'SignInPage.No such user': 'User does not exist or the password is incorrect',
    'SignUpPage.Forgot password': 'Forgot your password?',

    'CreatePasswordPage.create new password': 'Create new password',
    'CreatePasswordPage.new password': 'New password',
    'CreatePasswordPage.repeat password': 'Repeat',
    'CreatePasswordPage.save': 'Save',
    'CreatePasswordPage.fill in password': 'Enter your new password',
    'CreatePasswordPage.passwords must be the same': 'Passwords must be the same',
    'CreatePasswordPage.Cannot set password': 'Cannot save the password',
    'CreatePasswordPage.Success': 'Password have been successfully saved.',
    'CreatePasswordPage.sign in': 'Sign in',

    'ResetPasswordPage.fill in email': 'Enter email',
    'ResetPasswordPage.Wrong email': 'Invalid email',
    'ResetPasswordPage.Cannot reset password': 'Cannot reset password',
    'ResetPasswordPage.Email sent': 'Please follow the link sent to {email} to create a new password.',
    'ResetPasswordPage.reset password': 'Password reset',
    'ResetPasswordPage.Instructions will be sent':
        'Instructions for resetting your password will be sent to the entered email',
    'ResetPasswordPage.email': 'Email',
    'ResetPasswordPage.send': 'Send',

    'OrgHomePage.RegList': 'Registration list',
    'OrgHomePage.Upload': 'Upload papers',
    'OrgHomePage.Participants list': 'Participants list',
    'OrgHomePage.Exit': 'Exit',

    'OrgHomePage.Fill in RegList': 'Fill in registration list',
    'OrgHomePage.Upload papers': 'Upload papers',
    'OrgHomePage.Fill in details': "Enter participants' details",
    'OrgHomePage.TofT': 'Tournament of Towns',
    'OrgHomePage.Send for marking': 'Send for marking',

    'OrgHomePage.send success': 'Papers have been sent for marking.',

    'OrgHomePage.upload success title': 'Papers have been successfully uploaded.',
    'OrgHomePage.upload success note': 'To send them for marking, click the button at the bottom of this page.',
    'OrgHomePage.upload success': 'You can {uploadMore} or {viewParticipants}',
    'OrgHomePage.uploadMore': 'upload more',
    'OrgHomePage.viewParticipants': 'view the participants list',

    'OrgHomePage.fall': 'Fall',
    'OrgHomePage.spring': 'Spring',

    'OrgHomePage.wait': 'Paper submission will be available later.',

    'AdminHomePage.RegListsList': 'Reglists',
    'AdminHomePage.Exit': 'Exit',
    'AdminHomePage.TofT': 'Tournament of Towns',

    'RegListsList.No reglists': 'No reglists yet.',
    'RegListsList.townName': 'Town',
    'RegListsList.email': 'Email',
    'RegListsList.orgHeadName': 'President of org committee',
    'RegListsList.participantDraftsCount': 'Number of participants',

    'RegListAdmin.No such reglist': 'Registration list was not found',
    'RegListAdmin.town info': 'Town info',
    'RegListAdmin.participants list': 'Participants list',
    'RegListAdmin.no participants': 'No papers are yet uploaded',

    'RegList.town info': 'Town info',
    'RegList.contact info': 'Contacts',
    'RegList.tournament info': 'Tournament details',
    'RegList.save': 'Save',
    'RegList.required': 'Fill in this field',
    'RegList.global error': 'Error. Cannot save the registration list.',

    'RegList.townName': 'Town',
    'RegList.population': 'Population (including suburbs, depenting on how the Tournament is held)',
    'RegList.lastGrade': 'Last grade in your schools',
    'RegList.orgHeadName': 'Name of the President of the local organizing committee',
    'RegList.orgHeadPosition': 'Affilation and position of the President of the local organizing committee',
    'RegList.juryHeadName': 'Name of the President of the local jury',
    'RegList.juryHeadPosition': 'Affilation and position of the President of the local organizing jury',
    'RegList.address': 'Address for sending the diplomas and marked papers',
    'RegList.addressee': 'Addreessee',
    'RegList.email': 'Email',
    'RegList.phone': 'Phone (for emergency only)',
    'RegList.town pays': 'The town pays for the Tournament',
    'RegList.town does not pay': 'The town does not pay',
    'RegList.paymentData': 'Payment information',
    'RegList.invitations': 'Who is invited to the Tournament? (all students, or explain)',
    'RegList.pDate': 'Exact date of the sitting (O-level)',
    'RegList.mDate': 'Exact date of the sitting (A-level)',
    'RegList.tDate': 'Exact date of the sitting (O-level)',
    'RegList.vDate': 'Exact date of the sitting (A-level)',
    'RegList.pPapersNumber': 'Number of participants (O-level)',
    'RegList.mPapersNumber': 'Number of participants (A-level)',
    'RegList.tPapersNumber': 'Number of participants (O-level)',
    'RegList.vPapersNumber': 'Number of participants (A-level)',
    'RegList.participantsNumber': 'Number of participants  (count once those who participated in both versions)',
    'RegList.sentPPapersNumber': 'Number of papers sent to central examination (O-level)',
    'RegList.sentMPapersNumber': 'Number of papers sent to central examination (A-level)',
    'RegList.sentTPapersNumber': 'Number of papers sent to central examination (O-level)',
    'RegList.sentVPapersNumber': 'Number of papers sent to central examination (A-level)',
    'RegList.sentParticipantsNumber':
        'Number of authors of sent papers  (count once those who participated in both versions)',
    'RegList.rulesAreFollowed': 'Rules are observed',
    'RegList.ruleBreakersList': 'List of suspected cheating cases',
    'RegList.comments': 'Additional remarks',

    'EnterData.save': 'Save',
    'EnterData.name': 'Name',
    'EnterData.email': 'Email',
    'EnterData.grade': 'Grade',
    'EnterData.school': 'School',
    'EnterData.gender': 'Gender',

    'EnterData.round.p': 'O-level',
    'EnterData.round.m': 'A-level',
    'EnterData.round.t': 'O-level',
    'EnterData.round.v': 'A-level',
    'EnterData.required': 'Fill in',
    'EnterData.invalid email': 'Invalid email',
    'EnterData.global error': 'Error. Cannot upload the files.',
    'EnterData.gender.m': 'm',
    'EnterData.gender.f': 'f',

    'ParticipantList.name': 'Name',
    'ParticipantList.grade': 'Grade',
    'ParticipantList.school': 'School',
    'ParticipantList.email': 'Email',
    'ParticipantList.papers': 'Papers',
    'ParticipantList.round.p': 'o-level',
    'ParticipantList.round.m': 'a-level',
    'ParticipantList.round.t': 'o-level',
    'ParticipantList.round.v': 'a-level',
    'ParticipantList.no participants': 'You have not uploaded any papers. {uploadLink}',
    'ParticipantList.upload': 'Upload',

    'UploadPapers.Drop here': 'Drop files here or click to choose files.',
    'UploadPapers.File types': 'Each paper should be a separate zip or pdf file.',
    'UploadPapers.next': 'Next',
    'UploadPapers.added files': 'Added files',
    'UploadPapers.invalid files': 'Failed to add',
    'UploadPapers.invalid files subtitle': 'Rename the files (e.g. Moscow_Ivan_Ivanov_O_9.pdf) and try again',

    'Report.TofT': 'International Tournament of Towns',

    'Report.round.p': 'fall O-level',
    'Report.round.m': 'fall A-level',
    'Report.round.t': 'spring O-level',
    'Report.round.v': 'spring A-level',
    'Report.level.junior': 'junior',
    'Report.level.senior': 'senior',

    'Report.participant.nominal': 'participant',
    'Report.participant.plural': 'participants',

    'Report.paper.nominal': 'paper',
    'Report.paper.plural': 'papers',

    'Report.diploma.nominal': 'diploma',
    'Report.diploma.plural': 'diplomas',

    'Report.point.nominal': 'point',
    'Report.point.plural': 'points',

    'Report.grade': 'grade',
    'Report.marks': 'marks',
    'Report.points': 'points',
    'Report.result': 'result',
    'Report.total result': 'Total result',
    'Report.awarded with diploma': "Tournament Winner's Diploma",

    'Report.PresidentOfAll': 'President of the local Organising Committee and Jury',
    'Report.PresidentOfOrg': 'President of the local Organising Committee',
    'Report.PresidentOfJury': 'President of the local Jury',

    'Report.correction coeffs': 'Correction factors',
    'Report.junior': "junior's variant",
    'Report.senior': "senior's variant",

    'Report.threshold':
        "Participants who received {threshold} or more points are awarded Tournament Winner's Diplomas.",

    'PaperForm.round': 'Round',
    'PaperForm.level': 'Variant',
    'RegisterParticipants.add': 'Add participant',

    'Help.Drag files':
        "Choose or drop files. If they are named according to the requirements, participants' data will be parsed automatically.",
    'Help.Fill in': 'Fill in the remaining information and click the Save button.',
    'Help.Manual': "If the file names don't correspond to the schema, you can fill in all of the information manually.",
    'Help.close': 'Close',
};

export default messages;



// WEBPACK FOOTER //
// ./src/translations/en.js